<div class="d-flex flex-column flex-nowrap campaign-influencers-item">
  <div class="d-flex flex-g1">
    <div class="d-flex flex-row flex-auto campaign-influencers-content-wrapper">
      <div class="d-flex campaign-influencer-info">
        <div class="d-flex flex-row flex-auto open-influencer">
          <div class="d-flex flex-g1"></div>
          <div class="d-flex align-items-center" [ngClass]="{'flex-g5': !isCampaignDetails, 'flex-g8': isCampaignDetails}">
            <div class="d-flex flex-row flex-auto">
              <div class="d-flex align-items-center campaign-avatar-wrapper">
                <a (click)="openInfluencerCampaign(influencer.influencer_id, influencer.campaign_influencer_id, campaignId)">
                  <achoo-user-avatar [showCountryFlagIcon]="true"
                                     [userAvatarPicture]="influencer.influencer_profile_picture"
                                     [userCountryCode]="getCountryCode(influencer)"
                                     [avatarHeight]="5.3"
                                     [avatarWidth]="5.3"
                                     [countryHeight]="2"
                                     [countryWidth]="2"
                  ></achoo-user-avatar>
                </a>
              </div>
              <div class="d-flex align-items-center"
                   (click)="openInfluencerCampaign(influencer.influencer_id, influencer.campaign_influencer_id, campaignId)">
                <div class="nowrap-input d-flex flex-column justify-content-center">
                  <a class="nowrap-input campaign-influencer-name">{{ influencer.influencer_name }}</a>
                  <span class="campaign-influencer-country">{{influencer.country.name}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex header-small-title align-items-center justify-content-start campaign-influencer-status">
        <div class="d-flex flex-row align-items-center justify-content-center status-number {{ 'status-number-' + influencer.campaign_influencer_status }}">
          {{ influencer.campaign_influencer_status }}
        </div>
      </div>
      <div class="d-flex campaign-influencer-posts-platforms">
        <div class="d-flex flex-row flex-auto align-items-center">
          <div class="d-flex flex-g1 campaign-influencer-posts">
            <div class="border-left"></div>
            <span class="camp-number">{{ campaignInfluencerPost }}</span>
          </div>
          <div class="d-flex flex-g3 campaign-influencer-platforms">
            <div *ngFor="let platform of orderedPlatformList" class="campaign-icon-wrapper">
              <div class="{{platform.name.toLowerCase() + '-icon'}}" [ngClass]="{'unposted-icon': !hasPlatform(platform.name, influencer)}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex campaign-influencer-reach">
        <div class="d-flex flex-row flex-auto align-items-center">
          <div class="border-left"></div>
          <span class="camp-number">{{campaignInfluencerReach}}</span>
        </div>
      </div>
      <div class="d-flex campaign-influencer-engagement">
        <div class="d-flex flex-row flex-auto align-items-center">
          <div class="border-left"></div>
          <span class="camp-number">{{campaignInfluencerEngagement}}</span>
        </div>
      </div>
      <div class="d-flex campaign-influencer-impact-percent">
        <div class="d-flex flex-row flex-auto align-items-center">
          <div class="border-left"></div>
          <span class="camp-number">{{campaignInfluencerImpact | percentNumberSuffix}}</span>
        </div>
      </div>
      <div class="d-flex campaign-influencer-button">
        <div class="d-flex flex-row flex-auto align-items-center justify-content-end mr-20px">
          <a (click)="openInfluencerCampaign(influencer.influencer_id, influencer.campaign_influencer_id, campaignId)"
             placement="bottom-right" ngbTooltip="{{'info_box.campaign.arrow_icon' | translate}}" *ngIf="isCampaignDetails">
            <img height="30" src="assets/images/Arrow_Right.svg" width="20">
          </a>
          <a (click)="openInfluencerCampaign(influencer.influencer_id, influencer.campaign_influencer_id, campaignId)"
             placement="bottom-right" ngbTooltip="{{'info_box.campaign.arrow_icon' | translate}}" *ngIf="!isCampaignDetails">
            <img height="30" src="assets/images/Arrow_Right.svg" width="20">
          </a>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isLastItem" class="d-flex flex-g1 campaign-border-bottom"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaign-influencers-item/campaign-influencers-item.component.html